module.exports = __webpack_public_path__ + "static/sport/in2.9045773.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/in2.jpg
// module id = ndTe
// module chunks = 0